module.exports = __webpack_public_path__ + "img/login_button_login_up.0676dba8.png";